import QuestionGroupComponent from '../question-group';
import { useFindPermissions } from '../../../utils/helpers/useFindPermissions';
type StationsListProps = {
  stations: any;
};

const StationsList = ({ stations = [] }: StationsListProps) => {
  const { canAiAudit } = useFindPermissions();
  return (
    <div>
      {stations?.map((item: any, index: number) => (
        <QuestionGroupComponent
          key={index}
          data={item?.data}
          title={item?.title}
          index={index}
          aishow={canAiAudit}
        />
      ))}
    </div>
  );
};

export default StationsList;
